import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

/**
 * A short buzz from the shell. WebKit has no Vibration API and Android's web view ignores it
 * without the VIBRATE permission, so inside the shells a haptic has to come from native code.
 *
 *   <form data-controller="bridge--haptic" data-action="turbo:submit-start->bridge--haptic#tap">
 */
export default class extends BridgeComponent {
  static component = "haptic";

  tap() {
    this.send("tap");
  }
}
